import './src/utilities/reactDomFindDomNodePolyfill';
import('./src/bootstrap');
import('@fsa/app-info');
